import {
  mergeTyped,
  PromiseState,
  toSnackbarIsOpen,
  useDataStream,
  useStreamValue,
  useVoidEventAsStream
} from 'annotation-tools/utils';
import { useState } from 'react';
import { mapTo } from 'rxjs/operators';

export const useSnackbar = () => {
  const [snackbarState, setSnackbarState] = useState<PromiseState>('pending');
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');

  /* events */

  const [openSnackbar$, openSnackbar] = useVoidEventAsStream();
  const [closeSnackbarClick$, closeSnackbar] = useVoidEventAsStream();

  const snackbarIsOpen$ = useDataStream<boolean>(
    false,
    mergeTyped(
      openSnackbar$.pipe(toSnackbarIsOpen(2000)),
      closeSnackbarClick$.pipe(mapTo(false))
    )
  );

  const snackbarIsOpen = useStreamValue(snackbarIsOpen$, false);

  return {
    snackbarIsOpen,
    openSnackbar,
    closeSnackbar,
    snackbarState,
    setSnackbarState,
    snackbarMessage,
    setSnackbarMessage
  };
};
